module.exports = __webpack_public_path__ + "img/Filati-logo.5efc9ea4.png";